import React from 'react';
import MathJax from 'react-mathjax';
import Parser from 'html-react-parser';
import { string, func } from 'prop-types';

function Latex({ content, onRender }) {
  const parserOptions = {
    replace: domNode => (
      <MathJax.Node formula={domNode.data} inline onRender={onRender} />
    ),
  };

  return (
    <MathJax.Provider options={{ messageStyle: 'none' }}>
      {Parser(content, parserOptions)}
    </MathJax.Provider>
  );
}

Latex.propTypes = {
  content: string.isRequired,
  onRender: func,
};

Latex.defaultProps = {
  onRender: () => {},
};

export default Latex;



// WEBPACK FOOTER //
// ./app/components/Latex/Latex.jsx